import DiseaseEncyclopediaModel from '@/entities/disease-encyclopedia/model/diseaseEncyclopedia';
import { createDiseaseEncyclopediaDetailUrl } from '@/entities/disease-encyclopedia/util';
import ContentMarkDown from '@/shared/ui/content-mark-down/ContentMarkDown';
import Link from 'next/link';

interface Props {
  popularDiseaseEncyclopedia: DiseaseEncyclopediaModel[] | undefined;
  onClick: (disease: DiseaseEncyclopediaModel) => () => void;
}

const PopularDiseaseEncyclopedia = (props: Props) => {
  return (
    <div className='grid grid-cols-3 gap-x-[16px] gap-y-[24px] px-[24px] '>
      {props.popularDiseaseEncyclopedia?.map((disease) => (
        <Link key={`disease-encyclopedia-${disease.getPublicId()}`} href={createDiseaseEncyclopediaDetailUrl(disease)}>
          <a className='flex flex-col items-start gap-[12px] rounded-[8px]'>
            <div className='flex h-[152px] w-full flex-shrink-0 items-center justify-center overflow-hidden rounded-[8px] bg-gray-30 pr-[38px] pl-[40px]'>
              {disease.getTitleImageUrl() && (
                <img
                  src={disease.getTitleImageUrl() ?? undefined}
                  alt={disease.getTitle()}
                  className='h-[152px] w-[152px] object-cover'
                />
              )}
            </div>
            <div className='flex flex-col text-left'>
              <h3 className='typography-ui-17sb mb-1 line-clamp-1 overflow-ellipsis text-gray-900'>
                {disease.getTitle()}
              </h3>
              <span className='typography-ui-15m line-clamp-2 h-[44px] overflow-ellipsis text-left text-gray-400'>
                <ContentMarkDown
                  markdown={disease.getContent() ?? ''}
                  components={{
                    h2: (_node, ..._rest) => {
                      return <></>;
                    },
                    h3: (_node, ..._rest) => {
                      return <></>;
                    },
                    h4: (_node, ..._rest) => {
                      return <></>;
                    },
                    p: (node, ...rest) => {
                      return <p {...rest}>{node.children}</p>;
                    },
                  }}
                />
              </span>
            </div>
          </a>
        </Link>
      ))}
    </div>
  );
};

export default PopularDiseaseEncyclopedia;
